import React from "react";
import { Collapse, Spin } from "antd";
import "antd/dist/reset.css";
import "../styles/mainMenu.scss";
import useMenuState from "../states/MenuState";
import { componentTheme, customClasses } from "../themes/blueTheme";
import { variableIcons, otherIcons } from "../resources/menuIcons";
import {
  InfoCircleFilled,
  InfoCircleOutlined,
  SettingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import useMapState from "../states/MapState";

const { Collapse: collapseTheme } = componentTheme.components;
const { Panel } = Collapse;

const MainMenu = () => {
  const { menuItems } = useMenuState();
  return (
    <div className="mainMenu-container">
      <Collapse
        accordion
        defaultActiveKey={0}
        style={{
          borderRadius: collapseTheme.borderRadius,
          fontWeight: "bold",
          ...customClasses,
        }}
      >
        {menuItems.map((section, index) => (
          <Panel header={section.sectionName} key={index}>
            {section.options.map((option, idx) => (
              <Option key={idx} option={option} />
            ))}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};
const antIcon = <SyncOutlined style={{ fontSize: 15 }} spin />;

const Option = ({ option }) => {
  const { setOptionValue } = useMenuState();
  const { setResourceInfoId } = useMapState();

  const onChangeOption = () => {
    if (option.loading) return;
    setOptionValue(option.id, !option.checked);
  };

  const IconComponent =
    variableIcons[option.variable] ||
    otherIcons[option.icon] ||
    otherIcons.default;

  if (option.optionType === "actionable") {
    return (
      <div
        className="checkbox-option"
        onClick={onChangeOption}
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      >
        {/* <Spin spinning={option.loading === true} size="small"> */}
        <IconComponent
          style={{ color: option.checked ? "blue" : "black" }}
          alt="Icon description"
        />
        {/* </Spin> */}
        <span
          style={{
            marginLeft: "8px",
            color: collapseTheme.colorTextBase,
            fontWeight: 100,
          }}
        >
          {option.optionName}
          <InfoCircleOutlined
            style={{ fontSize: 13, marginLeft: "5px" }}
            onClick={(e) => {
              e.stopPropagation(); // Detiene la propagación del evento
              setResourceInfoId(option.id);
            }}
          />
        </span>
        {option.loading && (
          <Spin
            indicator={antIcon}
            style={{ marginLeft: 8, marginBottom: 0 }}
          />
        )}
      </div>
    );
  } else if (option.optionType === "dropdown") {
    return (
      <div style={{ color: collapseTheme.colorTextBase }}>
        <span style={{ fontWeight: "bold" }}>{option.optionName}</span>
        <div className="sub-panel-list">
          {option.options.map((subOption, idx) => (
            <Option key={idx} option={subOption} />
          ))}
        </div>
      </div>
    );
  }
};

export default MainMenu;
